export function LoadingPanel({ title }: { title: string }) {
  return (
    <section class="loading-panel" aria-live="polite">
      <div class="loading-line"></div>
      <h2>{title}</h2>
    </section>
  );
}

type ErrorPanelProps = {
  title: string;
  message: string;
  onRetry?: () => void;
  action?: {
    href: string;
    label: string;
  };
};

export function ErrorPanel({ title, message, action, onRetry }: ErrorPanelProps) {
  return (
    <section class="empty-state" role="alert">
      <h2>{title}</h2>
      <p>{message}</p>
      {onRetry && (
        <button class="secondary-action" type="button" onClick={onRetry}>
          Try again
        </button>
      )}
      {action && (
        <a class="secondary-action" href={action.href}>
          {action.label}
        </a>
      )}
    </section>
  );
}
